import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import { DASHBOARD_WEEKLY_TREND } from "@/api/graphql/operations/dashboard";

interface WeeklyTrendPoint {
  weekStart: string;
  keywordCount: number;
  channelCount: number;
  contentCount: number;
}

export function useWeeklyTrend() {
  return useQuery({
    queryKey: ["dashboard", "weekly-trend"],
    queryFn: () =>
      gqlRequest<{ dashboardWeeklyTrend: WeeklyTrendPoint[] }>(
        DASHBOARD_WEEKLY_TREND,
      ).then((d) =>
        d.dashboardWeeklyTrend.map((p) => ({
          week: p.weekStart,
          키워드: p.keywordCount,
          채널: p.channelCount,
          콘텐츠: p.contentCount,
        })),
      ),
    staleTime: 60_000,
  });
}
